/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon20Solid = forwardRef('TimeClockStopwatchIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2v1.062A8.001 8.001 0 0 0 10 19a8 8 0 0 0 6.32-12.906l1.387-1.387a1 1 0 0 0-1.414-1.414L14.906 4.68A7.96 7.96 0 0 0 11 3.062V2h1.5a1 1 0 1 0 0-2h-5a1 1 0 0 0 0 2H9Zm1 4a.75.75 0 0 1 .75.75V11a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 10 6Z" })));
});
